import React from "react"
import styled from "styled-components"
import { HelpCircle, Search, BookOpen, Flag, MessageSquare, FileText } from "lucide-react"

import { apiGet } from "../../../api"
import LeftSidebar from "../../components/left-sidebar"
import { AppLayout, FeedColumn, RightSidebar } from "../../constants/styles"
import TrendingPanel from "../../components/trending-panel"

const PageHeader = styled.div`
  padding: 1rem; border-bottom: 1px solid var(--border);
  h1 { font-size: 1.25rem; font-weight: 700; }
`
const SearchBar = styled.div`
  padding: 0.75rem 1rem; border-bottom: 1px solid var(--border);
  display: flex; align-items: center; gap: 0.5rem;
  input { flex: 1; border: none; outline: none; font-size: 0.875rem; background: transparent; }
`
const Categories = styled.div`
  display: flex; gap: 0; border-bottom: 1px solid var(--border);
`
const CatBtn = styled.button`
  flex: 1; padding: 0.75rem 0.5rem; background: none; border: none; cursor: pointer;
  font-size: 0.8rem; font-weight: ${(p) => p.$active ? 700 : 400};
  border-bottom: 2px solid ${(p) => p.$active ? "var(--primary)" : "transparent"};
  color: ${(p) => p.$active ? "var(--foreground)" : "var(--muted-foreground)"};
`
const Article = styled.article`
  padding: 1rem; border-bottom: 1px solid var(--border);
  h3 { font-size: 1rem; font-weight: 600; margin-bottom: 0.5rem; }
  p { font-size: 0.875rem; line-height: 1.6; color: var(--muted-foreground); white-space: pre-wrap; }
`
const Empty = styled.div`
  text-align: center; padding: 3rem; color: var(--muted-foreground);
`

const CAT_LABELS = {
  all: "All",
  guidelines: "Guidelines",
  how_to: "How To",
  reporting: "Reporting",
  faq: "FAQ"
}

export default function HelpPage() {
  const [articles, setArticles] = React.useState([])
  const [category, setCategory] = React.useState("all")
  const [search, setSearch] = React.useState("")
  const [loading, setLoading] = React.useState(true)

  const fetchArticles = React.useCallback(() => {
    setLoading(true)
    const params = new URLSearchParams()
    if (category !== "all") params.set("category", category)
    if (search.trim()) params.set("q", search.trim())
    apiGet(`/api/v1/communities/help?${params}`).then((res) => {
      if (res.parsedResponse?.articles) setArticles(res.parsedResponse.articles)
    }).finally(() => setLoading(false))
  }, [category, search])

  React.useEffect(() => { fetchArticles() }, [category])

  const handleSearch = (e) => {
    if (e.key === "Enter") fetchArticles()
  }

  return (
    <AppLayout>
      <LeftSidebar activePage="help" />
      <FeedColumn>
        <PageHeader><h1>Help Center</h1></PageHeader>
        <SearchBar>
          <Search size={16} color="var(--muted-foreground)" />
          <input placeholder="Search help articles..." value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={handleSearch} />
        </SearchBar>
        <Categories>
          {Object.entries(CAT_LABELS).map(([key, label]) => (
            <CatBtn key={key} $active={category === key} onClick={() => setCategory(key)}>{label}</CatBtn>
          ))}
        </Categories>
        {loading ? <Empty>Loading...</Empty> : articles.length === 0 ? (
          <Empty><HelpCircle size={48} /><h3>No articles found</h3></Empty>
        ) : articles.map((a) => (
          <Article key={a.id}>
            <h3>{a.title}</h3>
            <p>{a.content}</p>
          </Article>
        ))}
      </FeedColumn>
      <RightSidebar><TrendingPanel /></RightSidebar>
    </AppLayout>
  )
}
